import script from "./List.vue?vue&type=script&setup=true&lang=ts"
export * from "./List.vue?vue&type=script&setup=true&lang=ts"

import "./List.vue?vue&type=style&index=0&id=7f701806&lang=css"

export default script